import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import orange from '@material-ui/core/colors/orange';
import blue from '@material-ui/core/colors/blue';

const theme = createMuiTheme({
    typography: {
        useNextVariants: true,
        fontFamily: [
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"'
        ].join(',')
    },
    palette: {
        primary: {
            light: blue[700],
            main: blue[800],
            dark: blue[900]
        },
        secondary: {
            light: orange[300],
            main: orange[600],
            dark: orange[700]
        }
    }
});

export default theme;
